import httpRequest from "../utils/httpRequest";

export default {
    loginPlatform(params) { // 用户登录
        return httpRequest.post('/admin/auth/login', params);
    },
    getLastLoginTime(userId, params) {
        return httpRequest.get(`/log/logmanager/queryLogByUserId/${userId}`, params);
    },
    getUserInfo(params) { // 登录后获取用户信息
        return httpRequest.get("/checkAdmin/backUser/getUserInfo", params);
    },
    loginOut(params) { // 用户退出
        return httpRequest.get('/checkAdmin/auth/loginOut', params);
    },
    downLoadFile(fileId, params) { // 根据文件 id 下载文件
        return httpRequest.getResponse(`/portal/files/downloadFile/${fileId}`, params);
    },
    deleteFileById(fileId, params) { // 根据文件 id 删除文件
        return httpRequest.delete(`/portal/files/deleteFile/${fileId}`, params);
    },
    verificationCode(params) { // 验证码
        return httpRequest.get('/admin/verificationCode', params);
    },
    postSettledOrgList(params) { // 首页入驻机构
        return httpRequest.post('/portal/friendshipLinks/friendshipLinksList', params);
    },
    queryNewsInfoList(params) { // 新闻资讯
        return httpRequest.post('/portal/information/condition', params);
    },
    queryDictionaryByParentCode(code, params) { // 根据 code 查询所有子节点
        return httpRequest.get(`/dic/dictionary/byParentCode/${code}`, params);
    },
    queryDictionaryByCodes(params) { // 根据字典 code 合集查询子节点
        return httpRequest.post(`/dic/dictionary/byCodes`, params);
    },
    getRegionAll(parentId, params) { // 获取所有二级地区
        return httpRequest.get(`/dic/region/byParentId/${parentId}`, params);
    },
    visitInfomationDetail(infoId, params) { // 查询新闻资讯详情
        return httpRequest.get(`/portal/information/${infoId}`, params);
    },
    financialOrgEnquiries(params) {  // 金融机构列表查询
        return httpRequest.post('/admin/org/orgListPortal', params)
    },
    orgListByParent(params) {  // 金融机构详情分支列表
        return httpRequest.post('/admin/org/queryOrgListByParentIdPortal', params)
    },
    enquiriesOrgInfo(id, params) {  // 查询机构详情
        return httpRequest.get(`/admin/org/${id}`, params)
    },
    operateBanner(areaCode, params) { // 首页 运营位
        return httpRequest.get(`/portal/operatingPosition/getOperatingPositionList/${areaCode}`, params);
    },
    sendPhoneCode(phoneNum, params) { // 发送验证码
        return httpRequest.get(`/admin/backUser/registerSendCode/${phoneNum}`, params);
    },

    registerUserSysAuto(params) { // 企业用户注册
        return httpRequest.post(`/admin/backUser/registerUserSysAuto`, params);
    },
    registerEnterpriseUser(params) { // 企业用户注册
        return httpRequest.put(`/admin/backUser/registerUser`, params);
    },
    regionTree(params) { // 地区树
        return httpRequest.get("/dic/region/tree", params);
    },
    getFisrtOrgLevel(orgType, params) { // 获取所有一级金融机构
        return httpRequest.get(`/admin/org/getOrgDtoByLevel/${orgType}`, params);
    },
    queryEntInformation(creditCode, params) { // 根据企业名称、统一社会信用代码查询企业信息
        return httpRequest.get(`/checkPortal/enterpriseCredit/getGSJBXX/${creditCode}`, params);
    },
    userSubmitAndUpdate(params) { // 企业用户审核或修改
        return httpRequest.put(`/checkAdmin/backUser/userSubmitAndUpdate`, params);
    },
    insertPower(params) { // 新增电力申请信息
        return httpRequest.post(`/checkPortal/powerApply`, params);
    },
    insertLicense(params) { // 新增授权书申请信息
        return httpRequest.post(`/tax/taxLicense`, params);
    },
    taxRelated(params) { // 新增涉税数据查询申请信息
        return httpRequest.post('/tax/taxRelated', params);
    },
    checkAuth(params) { // 检查授权书是否在有效期内
        return httpRequest.post(`/tax/taxLicense/checkIsExpiration`, params);
    },
    getFinancialNeed(params) { // 获取融资需求
        return httpRequest.post(`/portal/financing/queryFinancingByPage`, params);
    },
    addFinancialNeed(params) { // 新增融资需求
        return httpRequest.post(`/checkPortal/financing`, params);
    },
    updateFinancialNeed(params) { // 根据 id 修改融资需求
        return httpRequest.put(`/checkPortal/financing`, params);
    },
    deleteFinancialNeed(id, params) { // 根据 id 删除融资需求
        return httpRequest.delete(`/checkPortal/financing/${id}`, params);
    },
    publishFinancialNeed(params) { // 发布、下架融资需求
        return httpRequest.post(`/checkPortal/financing/releaseFinancing`, params);
    },
    getFinancialNeedById(id, params) { // 根据 id 查询融资需求信息
        return httpRequest.get(`/portal/financing/${id}`, params);
    },
    getFillingBatchList(params) { // 查询批次
        return httpRequest.get(`/portal/fillingBatch/getFillingBatchList`, params);
    },
    addDemandReport(params) { // 新增融资上报
        return httpRequest.post(`/checkPortal/demandReport`, params);
    },
    getDemandReportByPage(params) { // 查询列表
        return httpRequest.post(`/portal/demandReport/getDemandReportByPage`, params);
    },
    demandApplyHistoryByPage(params) { // 需求上报 - 历史记录
        return httpRequest.post(`/portal/demandReport/demandApplyHistoryByPage`, params);
    },
    deleteDemandReport(id, params) { // 删除
        return httpRequest.delete(`/checkPortal/demandReport/${id}`, params);
    },
    queryDemandReportById(id, params) { // 根据id查询详情
        return httpRequest.get(`/portal/demandReport/queryDemandReportById/${id}`, params);
    },
    putDemandReport(params) { // 编辑增融资上报
        return httpRequest.put(`/checkPortal/demandReport`, params);
    },
    publishDemandReport(params) { // 发布融资上报
        return httpRequest.post(`/checkPortal/demandReport/autoAccept`, params);
    },
    queryDemandReportByBatchId(id, creditCode, params) { // 根据id查询详情
        return httpRequest.get(`/portal/demandReport/queryDemandReportByBatchId/${id}/${creditCode}`, params);
    },
    queryFeatureProductByType(featureType, params) {
        return httpRequest.get(`/portal/feature/queryFeatureProductByType/${featureType}`, params);
    },
    queryProdcutList(params) { // 查询金融产品
        return httpRequest.post(`/portal/productManage/queryProductManageByPage`, params);
    },
    getProductDetailById(productId, params) { // 根据 id 获取详情信息
        return httpRequest.get(`/portal/productManage/${productId}`, params);
    },
    applyProductInsert(params) { // 申请金融产品
        return httpRequest.post('/checkPortal/productApply', params);
    },

    applyProductInsertNew(params) { // 申请金融产品
        return httpRequest.post('/portal/productApply', params);
    },

    applyProductUpdate(params) { // 修改金融产品
        return httpRequest.put('/checkPortal/productApply', params);
    },
    getProductRecord(params) { // 获取金融产品申请记录
        return httpRequest.post('/portal/productApply/queryProductApplyByPage', params);
    },
    deleteProductRecord(recordId, params) { // 删除产品申请记录
        return httpRequest.delete(`/checkPortal/productApply/${recordId}`, params);
    },
    getProductRecordById(recordId, params) { // 根据申请记录 ID 获取详细信息
        return httpRequest.get(`/portal/productApply/${recordId}`, params);
    },
    queryNoticeByPage(params) { // 查询通知公告
        return httpRequest.post(`/portal/notice/queryNoticeByPage`, params);
    },
    helpCentreList(params) { // 根据帮助类型查询数据
        return httpRequest.post(`/portal/helpCentre/helpCentreList`, params);
    },
    getHelpCentre(id) { // 根据帮助类型查询数据
        return httpRequest.get(`/portal/helpCentre/${id}`);
    },
    recordLookProNum(params) { // 查看金融产品详情记录ip次数
        return httpRequest.post(`/portal/productManage/statisticsLookProductNum`, params);
    },
    portalQueryOrgDtoList(params) { // 查询金融机构列表
        return httpRequest.post(`/admin/org/portalQueryOrgDtoList`, params);
    },
    getOrgInfoById(orgId, params) { // 根据 ID 获取 机构所有信息
        return httpRequest.get(`/admin/org/${orgId}`, params)
    },
    queryProductByOrg(params) { // 获取金融产品根据金融机构ID
        return httpRequest.post(`/portal/productManage/queryProductManageByPage`, params);
    },
    queryOrgListByParentIdPortal(params) { // 根据金融机构ID获取分支机构
        return httpRequest.post(`/admin/org/queryOrgListByParentIdPortal`, params);
    },
    getEnterpriseInfo(name, pageIndex, pageSize) { // 根据企业名称或社会统一信用代码查询企业信息
        return httpRequest.get(`/portal/enterpriseCredit/getJBXXList/${name}/${pageIndex}/${pageSize}`);
    },
    getTaxLicenseInfo(params) { // 授权信息分页查询
        return httpRequest.post(`/tax/taxLicense/page`, params);
    },
    queryStockExchangePage(params) { // 股权服务查询接口
        return httpRequest.post(`/portal/stock/queryStockExchangePage`, params);
    },
    getStock(id, creditCode) { // 股权服务查询接口
        return httpRequest.get(`/portal/stock/queryStockExchangeByIdAndCreditCode/${id}/${creditCode}`);
    },
    stockApply(params) { // 股权服务申请
        return httpRequest.post(`/checkPortal/stockApply`, params);
    },
    queryStockExchangeRecommend(params) { // 股权服务推荐
        return httpRequest.get(`/portal/stock/queryStockExchangeRecommend`, params);
    },
    queryStockExchangeApplyByPage(params) { // 股权服务历史记录
        return httpRequest.post(`/portal/stockApply/queryStockExchangeApplyByPage`, params);
    },
    queryAdminProductManageByPage(params) { // 金融产品超市
        return httpRequest.post(`/portal/productManage/queryAdminProductManageByPage`, params);
    },
    queryFeatureProductList(params) { // 特色专区推广
        return httpRequest.post(`/portal/feature/queryFeatureProductList`, params);
    },
    getFeatureInfo(id) { // 特色专区推广
        return httpRequest.get(`/portal/feature/${id}`);
    },
    querySuccessCase(params) { // 最新成功案例
        return httpRequest.get(`/portal/financingStat/homePageSuccessCase`, params);
    },
    queryNewFinancialNeed(params) { // 最新融资需求
        return httpRequest.post(`/portal/financing/page`, params);
    },
    queryFinancingApplyByPage(params) { // 融资需求 - 历史记录
        return httpRequest.post(`/portal/financingApply/queryFinancingApplyByPage`, params)
    },
    statRegisterEnt() { // 统计 - 企业数量
        return httpRequest.get(`/admin/stat/statHomeRegisterEnt`);
    },
    statFinanceProduct() { // 统计 - 金融产品数
        return httpRequest.get(`/portal/financingStat/statFinanceProduct`);
    },
    statFinanceApply() { // 统计 - 融资笔数
        return httpRequest.get(`/portal/financingStat/statFinanceApply`);
    },
    statHomePageGather() { // 统计 - 总计数量
        return httpRequest.get(`/portal/financingStat/statHomePageGather`);
    },
    statFinanceSuccess() { // 统计 - 成功对接数
        return httpRequest.get(`/portal/financingStat/statFinanceSuccess`)
    },
    statApplyAmountSum(dataType) { // 统计 - 申请总金额
        return httpRequest.get(`/portal/financingStat/statApplyAmountSum/${dataType}`)
    },
    statMakeAmountSum(dataType) { // 统计 - 放款总金额
        return httpRequest.get(`/portal/financingStat/statMakeAmountSum/${dataType}`)
    },
    statFirstLoan() { // 统计 - 首贷中心汇总统计
        return httpRequest.get(`/portal/financingStat/statFirstLoan`)
    },
    insertReport(params) { // 生成报告
        return httpRequest.post(`/checkAdmin/goldTaxThrough`, params);
    },
    reportRecord(params) { // 查看报告生成记录
        return httpRequest.post(`/checkAdmin/goldTaxThrough/queryReportApplyPage`, params);
    },
    visitReport(id) { // 查看报告
        return httpRequest.get(`/checkAdmin/goldTaxThrough/generateToken/${id}`);
    },
    bankPageQuery(params) { // 预约开户银行列表
        return httpRequest.post(`/admin/bankAccount/bankPageQuery`, params);
    },
    queryBank(params) { // 预约开户银行查询
        return httpRequest.post(`/admin/bankAccount/queryBank`, params);
    },
    queryBankBranch(params) { // 预约开户银行网点列表
        return httpRequest.post(`/admin/bankAccount/queryBankBranch`, params);
    },
    bankAccount(params) { // 预约开户银行提交保存
        return httpRequest.post(`/admin/bankAccount`, params);
    },
    putBankAccount(params) { // 预约开户银行提交保存
        return httpRequest.put(`/admin/bankAccount`, params);
    },
    doApplyAppointmentInfoLZB(params) { // 兰州银行预约开户银行提交保存
        return httpRequest.post(`/admin/bankAccount/doApplyAppointmentInfoLZB`, params);
    },
    doApplyAppointmentInfoPDB(params) { // 浦发银行预约开户银行提交保存
        return httpRequest.post(`/admin/bankAccount/doApplyAppointmentInfoPDB`, params);
    },
    accountInformationQueryByPage(params) { // 开户记录查询
        return httpRequest.post(`/admin/bankAccount/accountInformationQueryByPage`, params);
    },
    getApplyOpenInfoByApplyId(params) { // 信息编辑或查看时查询开户信息
        return httpRequest.post(`/admin/bankAccount/getApplyOpenInfoByApplyId`, params);
    },
    applyOpenAcctQueryByPage(params) { // 开户记录查询
        return httpRequest.post(`/admin/bankAccount/applyOpenAcctQueryByPage`, params);
    },
    getById(id) { // 开户记录查询
        return httpRequest.get(`/admin/bankAccount/getById/${id}`);
    },
    getOrgList(params) { // 金融机构分页查询
        return httpRequest.post(`/admin/org/orgList`, params);
    },
    ssoSync(params) { // 统一认证接口
        return httpRequest.post(`/admin/sso/ssoSync`, params);
    },
    ssoLogin(params) { // 查询是否认证
        return httpRequest.post(`/admin/backUser/ssoLogin`, params);
    },
    queryImageByPage() { // 查询是否认证
        return httpRequest.post(`/portal/image/queryImageByPage`, {currentPageNum: 1, pageSize: 50});
    },
    changePassword(params) { // 查询是否认证
        return httpRequest.put(`/admin/backUser/changePassword`, params);
    },

// 基本信息 - 基本信息
    getGSJBXX(creditCode) {
        return httpRequest.get(`/checkPortal/enterpriseCredit/getGSJBXX/${creditCode}`);
    },

// 基本信息 - 股东信息
    getGDXX(creditCode) {
        return httpRequest.get(`checkPortal/QccResult/getEquityThroughList/${creditCode}`);
    },
// 基本信息 - 高管信息
    getGSGGXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSGGXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 基本信息 - 对外投资
    getGSDWTZ(creditCode) {
        return httpRequest.get( `checkPortal/QccResult/getForeignInvestmentList/${creditCode}`);
    },

// 司法风险 - 法院判决信息
    getGSFYPJXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/demandReport/querySfpmInformation/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 司法风险 - 被执行人信息
    getGSBZXRXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/demandReport/queryQzzxxxInformation/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 司法风险 - 失信人信息
    getSXRXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/demandReport/querySxrxxInformation/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营风险 - 经营异常
    getGSJYYCXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSJYYCXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营风险 - 行政处罚
    getGSXZCFXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/demandReport/queryXzcfxxInformation/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营风险 - 动产抵押
    getGSDCDYXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSDCDYXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },
    getDCDYXXbyID(rowId) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSDCDYDetail//${rowId}`);
    },

// 经营风险 - 司法拍卖
    getSFPMXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/querySfpm/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营信息 - 行政许可信息
    getGSXZXK(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSXZXK/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营信息 - 资质证书
    getGSZZZSXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSZZZSXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },
// 经营信息 - 荣誉信息
    getGSRYXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSRYXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营信息 - 税务评级
    getGSSWPJXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSSWPJXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营信息 - 进出口信息
    getGSJCKXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSJCKXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营信息 - 新闻舆情
    getGSXWYQXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSXWYQXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营信息 - 红名单
    getRedList(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getRedList/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 经营信息 - 黑名单
    getBlackList(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/demandReport/queryFrhmdInformation/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 知识产权 - 商标信息
    getGSSBXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSSBXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 知识产权 - 专利信息
    getGSZLXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSZLXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 知识产权 - 作品著作权
    getGSZPZZQXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSZPZZQXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 知识产权 - 软件著作权
    getGSRJZZQXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSRJZZQXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },

// 知识产权 - 网站信息
    getGSWZXX(creditCode, currentPageNum, pageSize) {
        return httpRequest.get(`checkPortal/enterpriseCredit/getGSWZXX/${creditCode}/${currentPageNum}/${pageSize}`
        );
    },
// 查看企业信用信息记录
    creditInformation(params) {
        return httpRequest.post(`checkPortal/creditInformation`, params);
    },

// 股权穿透
    getEquityThrough(mainId) {
        return httpRequest.get(`checkPortal/QccResult/getEquityThrough/${mainId}`);
    },

// 实际控制人
    getControlPeople(mainId) {
        return httpRequest.get(`checkPortal/QccResult/getControlPeople/${mainId}`);
    }
    ,
// 查询子节点数据
    getNodes(mainId, id, keyWord) {
        return httpRequest.get( `checkPortal/QccResult/getNodes/${mainId}?id=${id}&keyWord=${keyWord}`);
    },
    getAdvisoryStat() { // 统计 - 首贷中心汇总统计
        return httpRequest.get(`/portal/Advisory/statAdvisoryRet`)
    },
    // 查询中介服务信息列表
    qryAdvisoryInfoList(params) {
        return httpRequest.post(`portal/Advisory/qryAdvisorySvcByPage`, params);
    },


    qryAdvisoryAnsInfos(params) {
        return httpRequest.post(`portal/Advisory/qryAdvisoryAnsByPage`, params);
    },

    addAdvisoryReqInfo(params) {
        return httpRequest.post(`portal/Advisory/addAdvisoryReqInfo`, params);
    },
    addQuestionInfo(params) { // 查询是否认证
        return httpRequest.post(`/portal/MobileAppItf/AddQuestionInfo`, params);
    },



    // ---------------------  信用贷接口  -----------------------

    // 政策等级匹配
    selectPolicyLevelStatic(params){
      return httpRequest.post(`/api/system/index/selectPolicyLevelStatic`, params);
    },
    // 政策类型匹配
    selectPolicyTypeStatic(params){
      return httpRequest.post(`/api/system/index/selectPolicyTypeStatic`, params);
    },
    // 智慧政策列表
    selectPolicyList(params){
      return httpRequest.post(`/api/system/index/selectPolicyList`, params);
    }
    
}



// WEBPACK FOOTER //
// ./src/interfaceAPI/index.js